var _path, _g, _path2, _path3, _g2, _path4, _g3, _g4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9557 17.9999C132.62 17.9999 168.427 49.6882 168.427 91.3528C168.427 129.536 129.139 151 90.9557 151C51.3709 151 9 130.938 9 91.3528C9 48.3997 48.0027 17.9999 90.9557 17.9999Z",
    fill: "url(#paint0_linear_5965_33751)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5965_33751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.502 33.375C44.502 30.303 46.9924 27.8125 50.0645 27.8125H127.939C131.011 27.8125 133.502 30.303 133.502 33.375V133.5C133.502 136.572 131.011 139.062 127.939 139.062H50.0645C46.9924 139.062 44.502 136.572 44.502 133.5V33.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0031 39.6328H125.001C126.316 39.6328 127.244 40.5679 127.244 41.5599V136.44C127.244 137.432 126.316 138.367 125.001 138.367H53.0031C51.6876 138.367 50.7598 137.432 50.7598 136.44V41.5599C50.7598 40.5679 51.6876 39.6328 53.0031 39.6328ZM79.2676 32.6797H97.3457C97.7297 32.6797 98.041 32.991 98.041 33.375C98.041 33.759 97.7297 34.0703 97.3457 34.0703H79.2676C78.8835 34.0703 78.5723 33.759 78.5723 33.375C78.5723 32.991 78.8835 32.6797 79.2676 32.6797ZM104.994 33.375C104.994 33.759 104.683 34.0703 104.299 34.0703C103.915 34.0703 103.604 33.759 103.604 33.375C103.604 32.991 103.915 32.6797 104.299 32.6797C104.683 32.6797 104.994 32.991 104.994 33.375Z",
    fill: "#D1D3D8",
    stroke: "#D1D3D8",
    strokeWidth: 1.39063
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 139.156V58.4062C133.5 52.2621 128.519 47.2812 122.375 47.2812H55.625C49.4808 47.2812 44.5 52.2621 44.5 58.4062V139.156C56.0185 149.487 71.1249 155.75 87.665 155.75H90.335C106.875 155.75 121.981 149.487 133.5 139.156Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.938 143.627V41.997C127.938 40.3073 126.622 38.9375 124.999 38.9375H53.0012C51.3782 38.9375 50.0625 40.3073 50.0625 41.997V143.627C60.7001 151.265 73.6692 155.75 87.665 155.75H90.335C104.331 155.75 117.3 151.265 127.938 143.627Z",
    fill: "#D1D3D8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_5965_33751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.971 54.2344H25.0332C21.9611 54.2344 19.4707 56.7248 19.4707 59.7969V98.7344C19.4707 101.806 21.9611 104.297 25.0332 104.297H152.971C156.043 104.297 158.533 101.806 158.533 98.7344V59.7969C158.533 56.7248 156.043 54.2344 152.971 54.2344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.627 62.5781H33.377C31.8409 62.5781 30.5957 63.8233 30.5957 65.3594V73.7031C30.5957 75.2392 31.8409 76.4844 33.377 76.4844H144.627C146.163 76.4844 147.408 75.2392 147.408 73.7031V65.3594C147.408 63.8233 146.163 62.5781 144.627 62.5781Z",
    stroke: "#D1D3D8",
    strokeWidth: 1.39063
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.064 66.75H38.9395C37.4034 66.75 36.1582 67.9952 36.1582 69.5312C36.1582 71.0673 37.4034 72.3125 38.9395 72.3125H139.064C140.6 72.3125 141.846 71.0673 141.846 69.5312C141.846 67.9952 140.6 66.75 139.064 66.75Z",
    fill: "#D1D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.627 82.0469H33.377C31.8409 82.0469 30.5957 83.2921 30.5957 84.8281V93.1719C30.5957 94.7079 31.8409 95.9531 33.377 95.9531H144.627C146.163 95.9531 147.408 94.7079 147.408 93.1719V84.8281C147.408 83.2921 146.163 82.0469 144.627 82.0469Z",
    stroke: "#D1D3D8",
    strokeWidth: 1.39063
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.377 85.5234H38.9395C37.4034 85.5234 36.1582 86.7686 36.1582 88.3047C36.1582 89.8407 37.4034 91.0859 38.9395 91.0859H122.377C123.913 91.0859 125.158 89.8407 125.158 88.3047C125.158 86.7686 123.913 85.5234 122.377 85.5234Z",
    fill: "#D1D3D8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.784 24.297C141.752 24.2724 141.728 24.2388 141.716 24.2006C141.206 22.2892 140.743 20.98 139.822 20.0624C138.896 19.1406 137.594 18.7 135.703 18.227L135.69 18.2238L135.677 18.2211C135.659 18.2172 135.642 18.2068 135.631 18.1918L135.625 18.183L135.618 18.1744C135.597 18.1486 135.586 18.1166 135.586 18.0836L135.586 18.0695L135.586 18.0554C135.585 18.0334 135.593 18.0118 135.607 17.995L135.615 17.9852L135.623 17.9751C135.648 17.9425 135.683 17.9183 135.723 17.9058C137.642 17.3981 138.956 16.9377 139.877 16.0206C140.803 15.0982 141.246 13.8007 141.721 11.9172L141.742 11.8335V11.8203H141.913L141.937 11.9087C142.448 13.8176 142.911 15.1246 143.834 16.0434C144.758 16.964 146.058 17.4097 147.949 17.8918L148.034 17.9133H148.073C148.074 17.9147 148.075 17.916 148.076 17.9174C148.084 17.9353 148.088 17.9547 148.088 17.9745L148.086 18.0493L148.089 18.0598H148.05L147.962 18.0831C146.045 18.592 144.734 19.0525 143.811 19.9708C142.886 20.8919 142.438 22.1875 141.953 24.071L141.933 24.1491L141.932 24.2297C141.931 24.2569 141.92 24.2828 141.901 24.302L141.9 24.3028C141.884 24.3188 141.863 24.3295 141.841 24.3339C141.83 24.3311 141.819 24.3256 141.809 24.3177L141.797 24.307L141.784 24.297ZM166.18 44.5C166.18 45.6522 165.246 46.5859 164.094 46.5859C162.941 46.5859 162.008 45.6522 162.008 44.5C162.008 43.3478 162.941 42.4141 164.094 42.4141C165.246 42.4141 166.18 43.3478 166.18 44.5Z",
    fill: "#BBBEC5",
    stroke: "#BBBEC5",
    strokeWidth: 1.39063
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_5965_33751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.377 155.75C42.5932 155.75 50.0645 148.278 50.0645 139.062C50.0645 129.846 42.5932 122.375 33.377 122.375C24.1607 122.375 16.6895 129.846 16.6895 139.062C16.6895 148.278 24.1607 155.75 33.377 155.75Z",
    fill: "#0ACD95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6777 137.324H39.3831C39.2543 136.879 39.0764 136.45 38.8525 136.045L39.7683 135.13C39.8653 135.033 39.9422 134.918 39.9947 134.791C40.0471 134.665 40.0741 134.529 40.0739 134.392C40.0739 134.115 39.9639 133.85 39.7683 133.654L38.7844 132.672C38.5888 132.476 38.3236 132.367 38.047 132.367C37.7705 132.367 37.5052 132.476 37.3096 132.672L36.3932 133.588C35.9884 133.364 35.5597 133.186 35.1152 133.057V131.762C35.1153 131.625 35.0883 131.489 35.036 131.363C34.9836 131.236 34.9067 131.121 34.8099 131.024C34.713 130.927 34.598 130.85 34.4715 130.798C34.3449 130.746 34.2092 130.719 34.0723 130.719H32.6816C32.5447 130.719 32.409 130.746 32.2824 130.798C32.1559 130.85 32.0409 130.927 31.944 131.024C31.8472 131.121 31.7703 131.236 31.718 131.363C31.6656 131.489 31.6386 131.625 31.6387 131.762V133.057C31.1941 133.186 30.7652 133.364 30.36 133.588L29.4436 132.672C29.248 132.476 28.9828 132.367 28.7062 132.367C28.4296 132.367 28.1644 132.476 27.9688 132.672L26.9849 133.655C26.8391 133.801 26.7397 133.987 26.6994 134.189C26.6592 134.392 26.6798 134.601 26.7587 134.792C26.8111 134.919 26.888 135.034 26.9849 135.131L27.9014 136.046C27.6772 136.451 27.4992 136.88 27.3708 137.324H26.0762C25.9392 137.324 25.8035 137.351 25.677 137.403C25.5504 137.456 25.4354 137.533 25.3386 137.63C25.2417 137.726 25.1649 137.841 25.1125 137.968C25.0601 138.095 25.0331 138.23 25.0332 138.367V139.758C25.0332 140.035 25.1431 140.3 25.3387 140.495C25.5342 140.691 25.7996 140.801 26.0762 140.801H27.3708C27.4994 141.246 27.6773 141.675 27.9014 142.08L26.9842 142.997C26.7888 143.192 26.6789 143.457 26.6789 143.734C26.6789 144.01 26.7887 144.276 26.9842 144.472L27.9674 145.455C28.1668 145.643 28.4308 145.747 28.7051 145.747C28.9793 145.747 29.2431 145.643 29.4429 145.455L30.3593 144.539C30.7647 144.763 31.1938 144.941 31.6387 145.07V146.363C31.6387 146.64 31.7485 146.906 31.9442 147.1C32.1397 147.296 32.405 147.406 32.6816 147.406H34.0723C34.2093 147.406 34.3449 147.379 34.4715 147.327C34.598 147.274 34.713 147.197 34.8097 147.1C34.9067 147.004 34.9835 146.889 35.036 146.762C35.0884 146.636 35.1153 146.5 35.1152 146.363V145.07C35.5595 144.941 35.9883 144.763 36.3939 144.54L37.3103 145.455C37.4071 145.552 37.522 145.629 37.6485 145.682C37.7751 145.734 37.9107 145.761 38.0477 145.761C38.1847 145.761 38.3204 145.734 38.4469 145.682C38.5734 145.629 38.6884 145.552 38.7851 145.455L39.7683 144.472C39.9637 144.277 40.0736 144.011 40.0736 143.735C40.0736 143.458 39.9638 143.193 39.7683 142.998L38.8525 142.082C39.0767 141.677 39.2546 141.247 39.3831 140.802H40.6777C40.8148 140.802 40.9506 140.775 41.0771 140.723C41.2678 140.644 41.4307 140.51 41.5453 140.338C41.6599 140.166 41.7209 139.964 41.7207 139.758V138.367C41.7208 138.23 41.6938 138.095 41.6414 137.968C41.589 137.841 41.5122 137.726 41.4153 137.63C41.3185 137.533 41.2035 137.456 41.0769 137.403C40.9504 137.351 40.8147 137.324 40.6777 137.324ZM33.377 142.539C32.6895 142.539 32.0175 142.335 31.4455 141.954C30.8738 141.571 30.4282 141.028 30.1651 140.393C29.902 139.758 29.8331 139.059 29.9671 138.384C30.1013 137.71 30.4324 137.09 30.9186 136.604C31.2822 136.241 31.7218 135.963 32.2058 135.789C32.6898 135.616 33.2061 135.553 33.7177 135.603C34.2292 135.653 34.7232 135.817 35.1642 136.081C35.6051 136.345 35.982 136.704 36.2676 137.131C36.6496 137.703 36.8535 138.375 36.8535 139.062C36.8526 139.984 36.4861 140.868 35.8343 141.52C35.1825 142.172 34.2987 142.538 33.377 142.539Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_5965_33751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.018 107.179L123.73 98.805C123.596 98.7514 123.452 98.7279 123.308 98.7361C123.164 98.7443 123.023 98.784 122.896 98.8525C122.769 98.9209 122.658 99.0164 122.572 99.1323C122.486 99.2481 122.426 99.3814 122.397 99.5228C122.358 99.7121 122.376 99.9085 122.448 100.088L130.822 120.376C130.901 120.565 131.036 120.725 131.21 120.834C131.383 120.942 131.586 120.995 131.79 120.983C131.995 120.971 132.19 120.896 132.35 120.768C132.51 120.64 132.626 120.466 132.682 120.269L135.14 111.666C135.152 111.626 135.173 111.589 135.203 111.56C135.233 111.53 135.27 111.509 135.31 111.497L143.912 109.039C144.109 108.983 144.283 108.867 144.411 108.707C144.539 108.547 144.614 108.351 144.626 108.147C144.637 107.943 144.585 107.74 144.477 107.566C144.367 107.393 144.207 107.258 144.018 107.179Z",
    fill: "#6940F2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.687 116.117C140.687 116.117 153.009 122.375 149.587 129.328C144.987 138.671 128.569 134.454 120.15 140.453C113.713 145.039 111.25 156.445 111.25 156.445",
    stroke: "#BBBEC5",
    strokeWidth: 1.39063,
    strokeLinecap: "round",
    strokeDasharray: "2.78 2.78"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5965_33751",
    x: 36.1582,
    y: 25.0312,
    width: 105.688,
    height: 127.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5965_33751",
    result: "effect2_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5965_33751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_5965_33751",
    x: 11.127,
    y: 51.4531,
    width: 155.75,
    height: 66.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5965_33751",
    result: "effect2_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5965_33751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_5965_33751",
    x: 8.3457,
    y: 119.594,
    width: 50.0625,
    height: 50.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5965_33751",
    result: "effect2_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5965_33751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_5965_33751",
    x: 114.033,
    y: 95.9532,
    width: 38.9375,
    height: 38.9374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5965_33751",
    result: "effect2_dropShadow_5965_33751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5965_33751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5965_33751",
    x1: 88.7137,
    y1: 17.9999,
    x2: 88.7137,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D3D8",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBroadcast);
export default __webpack_public_path__ + "static/media/no-broadcast.a5fae52d1108f23bdada57da371a56cd.svg";
export { ForwardRef as ReactComponent };